import { yupResolver } from '@hookform/resolvers/yup';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { object, string } from 'yup';
import { Decision } from '../../../../common/constants/decision';

export interface WaiveFormData {
  updateReason?: string;
  decision: Decision;
  description: string;
}

const initialFormData: Partial<WaiveFormData> = {
  decision: Decision.WAIVED,
  description: '',
  updateReason: '',
};

const decisions = Object.values(Decision);

const getSchema = ({ isUpdate }: WaiveFormOptions) =>
  object().shape({
    updateReason: isUpdate ? string().required('Required field') : string(),
    decision: string<Decision>().oneOf(decisions).required('Required field'),
    description: string().required('Required field'),
  });

export interface WaiveFormOptions {
  isUpdate: boolean;
}

const useWaiveForm = (options: WaiveFormOptions) => {
  const { control, watch, handleSubmit, reset } = useForm<WaiveFormData>({
    defaultValues: initialFormData,
    resolver: yupResolver(getSchema(options)),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const clear = useCallback(() => {
    reset(initialFormData);
  }, [reset]);

  return { control, watch, handleSubmit, reset, clear };
};

export default useWaiveForm;
